export const translationStrings = ['common.buttons.logout'] as const;
